import React from "react";
import { Download } from "lucide-react";

type PngExportControlsProps = {
  pngThemeChoice: "current" | "light" | "dark";
  setPngThemeChoice: (v: "current" | "light" | "dark") => void;
  pngBackgroundChoice: "canvas" | "transparent";
  setPngBackgroundChoice: (v: "canvas" | "transparent") => void;
  pngExporting: boolean;
  onExport: () => void;
};

export function PngExportControls({ pngThemeChoice, setPngThemeChoice, pngBackgroundChoice, setPngBackgroundChoice, pngExporting, onExport }: PngExportControlsProps) {
  return (
    <div className="border-b border-[var(--color-border)] bg-[var(--color-panel)]/80 backdrop-blur px-3 py-2 md:px-5">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div>
          <div className="text-sm font-semibold">PNG-Export</div>
          <div className="text-xs text-[var(--color-muted)]">Wähle Theme/Hintergrund und exportiere als PNG.</div>
        </div>
        <div className="flex flex-col md:flex-row gap-3 md:items-center">
          <div className="flex items-center gap-2 text-xs text-[var(--color-muted)]">
            <label className="flex items-center gap-1">
              <input type="radio" name="png-theme" value="current" checked={pngThemeChoice === "current"} onChange={() => setPngThemeChoice("current")} />
              Aktuell
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="png-theme" value="light" checked={pngThemeChoice === "light"} onChange={() => setPngThemeChoice("light")} />
              Light
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="png-theme" value="dark" checked={pngThemeChoice === "dark"} onChange={() => setPngThemeChoice("dark")} />
              Dark
            </label>
          </div>
          <div className="flex items-center gap-2 text-xs text-[var(--color-muted)]">
            <label className="flex items-center gap-1">
              <input type="radio" name="png-bg" value="canvas" checked={pngBackgroundChoice === "canvas"} onChange={() => setPngBackgroundChoice("canvas")} />
              Hintergrund
            </label>
            <label className="flex items-center gap-1">
              <input type="radio" name="png-bg" value="transparent" checked={pngBackgroundChoice === "transparent"} onChange={() => setPngBackgroundChoice("transparent")} />
              Transparent
            </label>
          </div>
          <button className="btn btn-secondary inline-flex items-center gap-2" onClick={onExport} disabled={pngExporting}>
            {pngExporting ? <span>…</span> : <Download className="h-4 w-4" />} Als PNG speichern
          </button>
        </div>
      </div>
    </div>
  );
}
